import React from 'react';

import { string } from '@philips-emr/tws-core/lib/component/prop-types';

function CountryFlag({ country }) {
  return (
    <span className={`c-country-flag u-flag-icon u-flag-icon--${country.toLowerCase()}`}></span>
  );
}

CountryFlag.propTypes = {
  country: string,
};

CountryFlag.defaultProps = {
  country: '',
};

export default CountryFlag;
